export enum CrusadeFaction {
  "Imperium" = "IMPERIUM",
  "Chaos" = "CHAOS",
  "Aeldari" = "AELDARI",
  "Tyranids" = "TYRANIDS",
  "Orks" = "ORKS",
  "Necrons" = "NECRONS",
  "T'au Empire" = "TAU_EMPIRE",
}

export enum CampaignRole {
  "Player" = "PLAYER",
  "Admin" = "ADMIN",
}

export enum Rank {
  "Battle Ready" = "BATTLE_READY",
  "Blooded" = "BLOODED",
  "Battle Hardened" = "BATTLE_HARDENED",
  "Heroic" = "HEROIC",
  "Legendary" = "LEGENDARY",
}

export enum Requisition {
  INCREASE_SUPPLY_LIMIT,
  FRESH_RECRUITS,
  REARM_AND_RESUPPLY,
  REPAIR_AND_RECUPERATE,
  PSYCHIC_MEDITATIONS,
  SPECIALIST_REINFORCEMENTS,
  WARLORD_TRAIT,
  RELIC,
}

export enum BattleHonourType {
  BATTLE_TRAIT,
  WEAPON_ENHANCEMENT,
  PSYCHIC_FORTITUDE,
  CRUSADE_RELIC,
}

export enum BattleTraitCharacter {}

export enum BattleTraitMonster {}

export enum BattleTraitVehicle {}

export enum BattleTraitOther {}

export enum WeaponEnhancementMelee {}

export enum WeaponEnhancementRanged {}

export enum PsychicFortitude {}

export enum ArtificerRelic {}

export enum LegendaryRelic {}

export enum OutOfActionType {
  DEVASTATING_BLOW,
  BATTLE_SCAR,
}

export enum BatteScarCharacter {}

export enum BatteScarMonster {}

export enum BatteScarVehicle {}

export enum BatteScarOther {}

export enum BattleFieldRole {
  "HQ" = "HQ",
  "Troops" = "TROOPS",
  "Elites" = "ELITES",
  "Fast Attack" = "FAST_ATTACK",
  "Heavy Support" = "HEAVY_SUPPORT",
  "Dedicated Transport" = "TRANSPORT",
  "Flyer" = "FLYER",
  "Lord of War" = "LORD_OF_WAR",
  "Fortification" = "FORTIFICATION",
}

export enum UnitType {
  "Character" = "CHARACTER",
  "Monster" = "MONSTER",
  "Vehicle" = "VEHICLE",
  "Infantry" = "INFANTRY",
  "Other" = "OTHER",
}

export enum Agenda {}
